export default __webpack_public_path__ + "static/ryanheadshot2016-69d84958f9a7e943f5f433a7b500b073.png";